import React, { useState, useEffect, useReducer } from 'react';
import { Button, Col } from 'react-bootstrap';
import { NavLink } from "react-router-dom";
import { AuthContext } from "../../AuthContext";
import { UserNameData } from "../UserCredentials/UserNameData";
import { useViewPort } from "../Hooks/useViewPort";

const GdacsHome = (props) => {
    const authContext = React.useContext(AuthContext);
    const { width } = useViewPort();
    const breakpoint = 480;

    return (
        <div className={width < breakpoint ? "" : "alerts_container col-12"} style={{ paddingLeft: "15px", paddingRight: "15px" }}>
            <br />
            {width > 620 &&
                <>
                    <div className="row">
                        <Col xs={3}>
                        </Col>
                        <div className="col-9"><h4 className="d-flex justify-content-left" style={{ color: "#6d9baf", fontWeight: "bold" }}>About GDACS Events</h4>
                        </div>
                    </div>
                    <div className="row">
                        <Col xs={3}>
                        </Col>
                        <div className="col-9 p_summary"> You can set up your notifications profile here.
            </div>
                    </div>
                </>
            }
            {width < 620 &&
                <>
                    <UserNameData params={authContext.data} />
                    <br />
                    <div className="row">
                        <div className="col-3">
                        </div>
                    <div className="col-9"><h4 className="d-flex justify-content-left" style={{ color: "#6d9baf", fontWeight: "bold" }}>About GDACS Events</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3">
                        </div>
                        <div className="col-9 p_summary"> You can set up your notifications profile here.
            </div>
                    </div>
                </>
            }

            <br />
            <br />
            <div className="row">
                <div className="col-3" style={{ paddingLeft: "50px;" }}>
                    <NavLink to={{
                        pathname: 'EditProfile',
                        navIndex: 1
                    }}
                        className={"btn btn-primary " + (width < breakpoint ? 'btn-sm btn-block' : 'btn-block ')} style={{ maxWidth: "150px" }}>
                        Edit Profile
                    </NavLink>
                </div>
                <div className="col-9 p_summary">Select “Edit profile” to change or set the addresses on which you want to received notifications. You can set different alert preferences for different disaster types.
            </div>
            </div>
            <br />
            <br />
            <div className="row">
                <div className="col-3" style={{ paddingLeft: "50px;" }}>
                    <NavLink to={{
                        pathname: 'ChangePwd',
                    }}
                        className={"btn btn-primary " + (width < breakpoint ? 'btn-sm btn-block' : 'btn-block ')} style={{ maxWidth: "150px" }}>
                        Change Pwd
                    </NavLink>
                </div>
                <div className="col-9 p_summary">Click on the button you can change your password to safely manage your data.
            </div>
            </div>
            <br />
            <br />
            <div className="row">
                <div className="col-3" style={{ paddingLeft: "50px;" }}>
                    <NavLink to={{
                        pathname: 'UserDelete',
                    }}
                        className={"btn btn-primary " + (width < breakpoint ? 'btn-sm btn-block' : 'btn-block ')} style={{ maxWidth: "150px" }}>
                        {width < breakpoint ? "Delete Account" : "Unsubscribe"}
                    </NavLink>
                </div>
                <div className="col-9 p_summary">Unsubscribe from the service. Your account will be deleted.
                        </div>
            </div>
            <br />
            <br />
            <div className="row">
                <div className="col-3" style={{ paddingLeft: "50px;" }}>
                    <NavLink to={{
                        pathname: 'ValidateContainer',
                        params: props.params
                    }}
                        className={"btn btn-primary " + (width < breakpoint ? 'btn-sm btn-block' : 'btn-block ')} style={{ maxWidth: "150px" }}>
                        Validate
                    </NavLink>
                </div>
                <div className="col-9 p_summary">Validate your notification channel.
            </div>
            </div>
            <br />
            <br />
            <br />
            <br />
        </div>
    )
}

export { GdacsHome };